import React from 'react';
import ContactForm from './ContactForm';
import './ContactSection.css';

const ContactSection: React.FC = () => {
  return (
    <section id="contact" className="contact-section">
      <div className="contact-container">
        <ContactForm />
      </div>
    </section>
  );
};

export default ContactSection;